window.PlummeI18n.register('en', {
  "clo.focus.finalConfirmation": "I have reviewed the accounting basis, equity events, subsequent events and going concern. All necessary postings and assessments have been resolved. I approve closing the year. Approver and time are stored in the history.",
  "clo.focus.approve": "Approve",
  "clo.focus.startYear": "Accounting start year",
  "clo.focus.bankSetupMissing": "Enter the opening date and documented opening balance in the account setup below. Enter 0 if the balance was zero.",
  "clo.focus.bankStatements": "Bank statements are missing for periods",
  "clo.focus.bankUnsettled": "Periods to reconcile",
  "clo.focus.bankDifferences": "Resolve balance differences in bank reconciliation.",
  "clo.focus.bankUnconfigured": "Set up bank accounts with the correct ledger accounts for these recorded balances",
  "clo.focus.reconcile": "Complete reconciliation",
  "clo.focus.restore": "Restore size",
  "clo.focus.fullscreen": "Full screen",
  "clo.focus.notCalculated": "Not calculated",
  "clo.focus.taxScope": "Confirm tax regime",
  "clo.focus.rateHelp": "Ordinary Norwegian company tax is 22% from 2019. Confirm the regime before approving the calculation. Financial activity tax and special regimes require a separate assessment.",
  "clo.focus.industry": "Tax regime",
  "clo.focus.ordinary": "Ordinary tax regime",
  "clo.focus.special": "Special regime - requires review",
  "clo.focus.finance": "Subject to financial activity tax",
  "clo.focus.priorLoss": "Loss carried forward from prior years (also confirm 0)",
  "clo.focus.updateCalculation": "Save and calculate",
  "clo.focus.taxCalculation": "How tax is calculated",
  "clo.focus.resultBeforeTax": "Result before tax",
  "clo.focus.permanent": "+ Permanent differences (net)",
  "clo.focus.temporaryChange": "- Change in temporary differences",
  "clo.focus.lossApplied": "- Prior losses applied",
  "clo.focus.taxable": "= Taxable income",
  "clo.focus.rate": "Tax rate",
  "clo.focus.resolveRate": "Confirm the tax regime above",
  "clo.focus.payable": "= Current tax",
  "clo.focus.lossRemaining": "Loss carried forward",
  "clo.focus.deferredTax": "Deferred tax / tax asset",
  "clo.focus.temporary": "Temporary differences",
  "clo.focus.unrecognized": "Unrecognized tax asset (basis)",
  "clo.focus.deferredBasis": "Deferred tax basis",
  "clo.focus.deferredAmount": "Deferred tax / tax asset",
  "clo.focus.postingApproval": "Approve calculation and closing entries",
  "clo.focus.postingHelp": "Approval confirms you have reviewed the tax basis, differences and prior losses. Current tax and any change in deferred tax are posted when closing the accounting year. Existing postings are taken into account.",
  "clo.focus.postingAccounts": "Calculated current tax: debit 8300 / credit 2500",
  "clo.focus.reviewRequired": "Resolve the tax regime or special tax circumstances before approval.",
  "clo.focus.unsaved": "Save and calculate changes before approving.",
  "clo.focus.editDifferences": "Edit differences and specifications",
  "clo.checklist.custom.mappedDetail": "No accounts lack a mapping to the Plumme standard chart. Imported accounts are checked when included in the chart. This does not verify all tax-return mappings.",
  "clo.priorYear.closedDetail": "Accounting year {{year}} is closed.",
  "clo.priorYear.noActivity": "No accounting figures are recorded for {{year}} in Plumme. The start year alone does not determine whether the previous year needs closing.",
  'clo.wealth.bookBasisNotice': "Preliminary overview from the accounts. Amounts are book values, not finalized tax wealth values.",
  'clo.wealth.fixedAssetComparison': "Asset register: book value {{book}}, tax balance {{tax}}. Difference {{difference}} (book minus tax). A tax balance is not automatically a wealth valuation.",
  'clo.finalSummary.permanentAmount': "Permanent differences",
  'clo.finalSummary.temporaryAmount': "Temporary differences at year end",
  'clo.balanceGroup.vatReceivable': "VAT receivable",
  'clo.balanceGroup.debitReceivable': "Receivable – debit balance {{code}}",
});
